import Vue from 'vue';

const state = Vue.observable({
  splashCompleted: false,
  loading: false,
  redirectAfterLogin: localStorage.getItem('redirectAfterLogin') || '',
  redirectAfterActivate: localStorage.getItem('redirectAfterActivate') || ''
});

export const appStore = {
  state,
  setSplashCompleted(completed) {
    state.splashCompleted = !!completed;
  },
  setLoading(loading) {
    state.loading = !!loading;
  },
  setRedirectAfterLogin(path) {
    state.redirectAfterLogin = path || '';
    if (state.redirectAfterLogin) {
      localStorage.setItem('redirectAfterLogin', state.redirectAfterLogin);
    } else {
      localStorage.removeItem('redirectAfterLogin');
    }
  },
  setRedirectAfterActivate(path) {
    state.redirectAfterActivate = path || '';
    if (state.redirectAfterActivate) {
      localStorage.setItem('redirectAfterActivate', state.redirectAfterActivate);
    } else {
      localStorage.removeItem('redirectAfterActivate');
    }
  },
  clearRedirects() {
    this.setRedirectAfterLogin('');
    this.setRedirectAfterActivate('');
  }
};
